/** @format */

import {
	AccordionModule,
	AffirmPayLaterModule,
	CommonTimerModule,
	ExclusiveProductPanelModule,
	GoogleAdManagerComponent,
	PaypalPayLaterModule,
	ProTipsComponent,
	ProgressSpinnerModule
} from '@shared/components';
import {
	AddToCartButtonModule,
	AddToCartSectionComponent,
	AddToCartSuccessModule,
	ChangeStoreButtonModule,
	FulfillmentButtonsModule
} from '@pdp/add-to-cart/components';
import {
	AemArticlesModule,
	AppSnackbarComponent,
	BackToSearchResultsModule,
	BNPLComponent,
	BrandLinkComponent,
	BreadcrumbModule,
	FrequentlyBoughtTogetherModule,
	GtgtContentComponent,
	HighlightsModule,
	HomrRichContentComponent,
	HomrStatsSlidersComponent,
	HomrTextLinkComponent,
	HomrWireSpotComponent,
	NotifyMePanelComponent,
	PriceModule,
	ProductDescriptionModule,
	ProductImageCarouselModule,
	ProductImageViewerModule,
	ProductInfoSpecsComponent,
	PromotionModule,
	ReadyForNextRoundAddOnsComponent,
	ReturnPolicyModule,
	ShippingModule,
	ShoppableImageComponent,
	Sketchfab3dImageryComponent,
	SnackbarModule,
	StyliticsJumplinkComponent,
	StyliticsModule,
	StyliticsShopTheSetComponent,
	SyndigoModule,
	TechSpecsComponent,
	TextileLabelComponent,
	WarrantyButtonComponent,
	ProductInStoreServicesComponent
} from '@pdp/components';
import {
	AggregatedRatingModule,
	ReviewBVReviewsModule,
	ReviewHighlightContainerModule,
	ReviewHighlyRatedFeaturesComponent,
	ReviewHighlyRatedFeaturesModalComponent,
	ReviewMultimediaCountComponent,
	ReviewQuestionsAndAnswersV2Module,
	ReviewRatingSummaryStarsModule
} from '@product-reviews';
import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import {
	DSProductRecommendationsModule,
	ProductRecommendationsComponent,
	ProductRecommendationsRailComponent
} from '@product-recommendations/components';
import {
	ExclusiveProductAdModule,
	ExclusiveProductInfoModule,
	ExclusiveProductOverlayModule,
	ExclusiveProductPromoMessageModule
} from '@pdp/exclusive-products/components';
import {
	GoldMemberStatusModule,
	ScorecardPointsComponent,
	ScoreRewardComponent
} from '@scorecard/components';
import {
	HmfAlertBannerComponent,
	HmfButtonComponent,
	HmfTextLinkComponent
} from '@dsg-tech/homefield-angular';
import { HotOnSocialButtonComponent, ImagesCarouselComponent } from '@social-content/components';

import { AttributesModule } from '@pdp/attributes/components';
import { CommonModule } from '@angular/common';
import { CustomizeProductButtonModule } from '@pdp/custom/components';
import { DynamicProductTemplateModule } from '../shared/dynamic-product-template-module.interface';
import { HomrBannerComponent } from '@shared/homr/components';
import { InStockDefaultComponent } from './in-stock-default.component';

@NgModule({
	declarations: [InStockDefaultComponent],
	imports: [
		AccordionModule,
		AddToCartButtonModule,
		AddToCartSectionComponent,
		AddToCartSuccessModule,
		AemArticlesModule,
		AppSnackbarComponent,
		AffirmPayLaterModule,
		AggregatedRatingModule,
		AttributesModule,
		BackToSearchResultsModule,
		BNPLComponent,
		BrandLinkComponent,
		BreadcrumbModule,
		ChangeStoreButtonModule,
		CommonModule,
		CommonTimerModule,
		CustomizeProductButtonModule,
		DSProductRecommendationsModule,
		ExclusiveProductAdModule,
		ExclusiveProductInfoModule,
		ExclusiveProductOverlayModule,
		ExclusiveProductPanelModule,
		ExclusiveProductPromoMessageModule,
		FrequentlyBoughtTogetherModule,
		FulfillmentButtonsModule,
		GoldMemberStatusModule,
		GoogleAdManagerComponent,
		GtgtContentComponent,
		HighlightsModule,
		HmfAlertBannerComponent,
		HmfButtonComponent,
		HmfTextLinkComponent,
		HomrBannerComponent,
		HomrTextLinkComponent,
		HomrStatsSlidersComponent,
		HomrWireSpotComponent,
		HomrRichContentComponent,
		HotOnSocialButtonComponent,
		ImagesCarouselComponent,
		NotifyMePanelComponent,
		PaypalPayLaterModule,
		PriceModule,
		ProductDescriptionModule,
		ProductImageCarouselModule,
		ProductImageViewerModule,
		ProductInfoSpecsComponent,
		ProductRecommendationsComponent,
		ProductRecommendationsRailComponent,
		ProductInStoreServicesComponent,
		ProgressSpinnerModule,
		PromotionModule,
		ProTipsComponent,
		ReadyForNextRoundAddOnsComponent,
		ReturnPolicyModule,
		ReviewBVReviewsModule,
		ReviewHighlightContainerModule,
		ReviewHighlyRatedFeaturesComponent,
		ReviewHighlyRatedFeaturesModalComponent,
		ReviewMultimediaCountComponent,
		ReviewQuestionsAndAnswersV2Module,
		ReviewRatingSummaryStarsModule,
		ScorecardPointsComponent,
		ScoreRewardComponent,
		ShippingModule,
		ShoppableImageComponent,
		SnackbarModule,
		Sketchfab3dImageryComponent,
		StyliticsJumplinkComponent,
		StyliticsModule,
		StyliticsShopTheSetComponent,
		SyndigoModule,
		TechSpecsComponent,
		TextileLabelComponent,
		WarrantyButtonComponent
	],
	providers: []
})
export class InStockDefaultModule implements DynamicProductTemplateModule<InStockDefaultComponent> {
	constructor(private readonly resolver: ComponentFactoryResolver) {}

	public resolveComponentFactory(): ComponentFactory<InStockDefaultComponent> {
		return this.resolver.resolveComponentFactory(InStockDefaultComponent);
	}
}
